import React from 'react'
import {
  Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Paper, InputBase, Checkbox
} from '@material-ui/core'

import moment from 'moment'

import { formatDateTimeToRender } from '../../../utils/functions'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '../../../layout/Header'
import Subheader from '../../../layout/Subheader'
import Loading from '../../../components/Loading'

import useStyles from './style'

function VisualizeRender ({ inputs, getCities, getLoading, getEstados, getJornadas }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Visualizar Colaborador" back="/app/colaboradores" />
      <div className={classes.content}>
      <div className={classes.rootPage}>
      {getLoading
        ? (<Loading />)
        : (
        <>
      <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Dados Pessoais</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                  <label className={classes.label}>Nome completo</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      style={{ textTransform: 'uppercase !important' }}
                      min
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome completo"
                      value={inputs.nome}
                      readOnly
                      name="nome"

                      onBlur
                      inputProps={{ minLength: 3, maxLength: 100 }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>
                    <select
                      className={classes.input}
                      value={inputs.status}
                      name="status"
                      required
                      disabled
                    >
                      <option value="">Selecione o status</option>
                      <option value="Contratado">Contratado</option>
                      <option value="Demitido">Demitido</option>
                      <option value="Afastado">Afastado</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Cpf</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                    readOnly
                    className={classes.input}
                    placeholder="CPF"
                    value={inputs.cpf}
                    inputProps={{ 'aria-label': 'cpf' }}
                  />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Rg</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="RG"
                      value={inputs.rg}
                      inputProps={{ 'aria-label': 'rg' }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Nome do pai</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome do pai"
                      value={inputs.nomePai}
                      name="nomePai"
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Nome da mãe</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome da mãe"
                      value={inputs.nomeMae}
                      name="nomeMae"
                      required
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Nome do conjuge</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome do conjuge"
                      value={inputs.nomeConjuge}
                      name="nomeConjuge"
                      required
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Estado civil</label>
                  <Paper className={classes.medium} elevation={0}>

                  <InputBase
                  readOnly
                  className={classes.input}
                  placeholder="Estado Civil"
                  value={inputs.estadoCivil}
                  inputProps={{ 'aria-label': 'estado civil' }}
                />

                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Data de nascimento</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="Data de nascimento"
                      value={moment(inputs.dataNascimento).format('DD/MM/YYYY')}
                      inputProps={{ 'aria-label': 'data de nascimento' }}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Endereço</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                <label className={classes.label}>Cep</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                  readOnly
                  className={classes.input}
                  placeholder="CEP"
                  value={inputs.cep}
                  inputProps={{ 'aria-label': 'cep' }}
                />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                 <label className={classes.label}>Logradouro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Logradouro"
                      name="logradouro"
                      required
                      value={inputs.logradouro}
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                 <label className={classes.label}>Bairro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Bairro"
                      name="bairro"
                      required
                      value={inputs.bairro}
                      readOnly
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Estado</label>
                  <Paper className={classes.medium} elevation={0}>
                    <select
                      className={classes.input}
                      disabled
                      value={inputs.estadoId}
                      name="estadoId"
                    >
                      <option>Selecione o estado</option>
                      {getEstados.map(estado => (
                        <option key={estado.estadoId} value={estado.estadoId}>{estado.estado}</option>
                      ))}
                    </select>
                  </Paper>
                </Grid>

                <Grid item xs={4}>
                 <label className={classes.label}>Complemento</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Complemento"
                      name="complemento"
                      required
                      value={inputs.complemento}
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2} className={classes.itemSmall}>
                  <label className={classes.label}>Número</label>
                  <Paper className={classes.small} elevation={0}>
                    <InputBase
                      className={classes.input}
                      type="text"
                      placeholder="Número"
                      name="numero"
                      required
                      value={inputs.numero}
                      readOnly
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Município</label>
                <Paper className={classes.medium} elevation={0}>
                <select
                  className={classes.input}
                  value={inputs.municipioId}
                  name="municipioId"
                  disabled="disabled"
                >
                  {getCities.map(city => (
                    <option key={city.municipioId} value={city.municipioId}>{city.municipio}</option>
                  ))}
                </select>
                    </Paper>
                </Grid>

              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Contato</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                <label className={classes.label}>Telefone 1</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                    readOnly
                    className={classes.input}
                    value={`(${inputs.ddd1}) ${inputs.telefone1}`}
                    placeholder="Telefone 1"
                    inputProps={{ 'aria-label': 'telefone 1' }}
                  />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Telefone 2</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      value={`(${inputs.ddd2}) ${inputs.telefone2}`}
                      placeholder="Telefone2"
                      inputProps={{ 'aria-label': 'telefone 2' }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                <label className={classes.label}>E-mail</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      classes={{ input: classes.inputEmail }}
                      placeholder="E-mail"
                      name="email"
                      required
                      value={inputs.email}
                      readOnly
                    />
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>
                Dados Profissionais
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                <label className={classes.label}>Pis</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="PIS"
                      value={inputs.pis}
                      inputProps={{ 'aria-label': 'pis' }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Número da ctps</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                        readOnly
                        className={classes.input}
                        placeholder="Número da CTPS"
                        value={inputs.ctpsNumero}
                        inputProps={{ 'aria-label': 'numero da ctps' }}
                      />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Série da ctps</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="Série da CTPS"
                      value={inputs.ctpsSerie}
                      inputProps={{ 'aria-label': 'serie da ctps' }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                  <label className={classes.label} style={{ marginLeft: '3%' }}>Data de admissão</label>
                  <Paper className={classes.small} style={{ marginLeft: '3%' }} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="Data de admissão"
                      value={moment(inputs.dataAdmissao).format('DD/MM/YYYY')}
                      inputProps={{ 'aria-label': 'data de admissao' }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                  <label className={classes.label} >Contrato Experiencia</label>
                  <Paper className={classes.medium} elevation={0}>
                    <select
                      className={classes.input}
                      value={inputs.contratoExperiencia}
                      name="contratoExperiencia"
                      readOnly
                      disabled
                    >
                      <option value="">Contrato Experiencia</option>
                      <option value="Trinta_Dias_Mais_Trinta_Dias">30 dias mais 30 dias</option>
                      <option value="Quarenta_e_Cinco_Dias_Mais_Quarenta_e_Cinco_Dias">45 dias mais 45 dias</option>
                      <option value="Noventa_Dias">90 dias</option>
                      <option value="SemContrato">Sem Contrato</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                  <label className={classes.label} style={{ marginLeft: '3%' }}>Grau de instrução</label>
                  <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                    <select
                      className={classes.input}
                      value={inputs.grauInstrucao}
                      name="grauInstrucao"
                      required
                      disabled
                    >
                      <option value="">Grau de instrução</option>
                      <option value="Analfabeto">Analfabeto</option>
                      <option value="PrimeiroGrauIncompleto">Primeiro grau incompleto</option>
                      <option value="PrimeiroGrauCompleto">Primeiro grau completo</option>
                      <option value="SegundoGrauIncompleto">Segundo grau incompleto</option>
                      <option value="SegundoGrauCompleto">Segundo grau completo</option>
                      <option value="SuperiorIncompleto">Superior Incompleto</option>
                      <option value="SuperiorCompleto">Superior Completo</option>
                    </select>
                  </Paper>
                </Grid>

                <Grid item xs={6} className={classes.grid2}>
                  <label className={classes.label} >Salário-Família</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      value={inputs.salarioFamilia}
                      name="salarioFamilia"
                      required
                      disabled
                    >
                      {inputs.qtdFilhosMenor14Anos > 0
                        ? (
                        <>
                          <option value="">Salário-Família</option>
                          <option value="Sim">Sim</option>
                          <option value="Nao">Não</option>
                        </>
                          )
                        : (
                          <option value="Nao">Não</option>
                          )}
                    </select>
                  </Paper>
                </Grid>

                <Grid item xs={6} className={classes.grid2}>
                <label className={classes.label} style={{ marginLeft: '3%' }}>Quantidade de filhos menores de 14 anos</label>
                <Paper style={{ marginLeft: '3%' }} className={classes.medium} elevation={0}>
                  <InputBase
                      className={classes.input}
                      placeholder="QUANTIDADE DE FILHOS MENORES DE 14 ANOS"
                      value={inputs.qtdFilhosMenor14Anos}
                      type="number"
                      required
                      disabled
                      name="qtdFilhosMenor14Anos"
                      readOnly
                    />
                </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                <label className={classes.label}>Receber vale transporte</label>
                <Paper className={classes.medium} elevation={0}>
                  <select
                    className={classes.input}
                    value={inputs.receberValeTransporte}
                    name="receberValeTransporte"
                    required
                    disabled
                  >
                      <option value="">Receber vale transporte</option>
                      <option value="Sim">Sim</option>
                      <option value="Nao">Não</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                <label className={classes.label}>Jornada de trabalho</label>
                <Paper className={classes.medium} elevation={0}>
                  <select
                    className={classes.input}
                    value={inputs.jornadaTrabalhoId}
                    name="jornadaTrabalhoId"
                    required
                    disabled
                  >
                    <option value="">Selecione a jornada de trabalho</option>
                    {getJornadas.map(jornada => (
                        <option key={jornada.jornadaTrabalhoId} value={jornada.jornadaTrabalhoId}>{jornada.nome}</option>
                    ))}
                  </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                <label className={classes.label} style={{ marginLeft: '3%' }}>Salário</label>
                  <Paper className={classes.small} style={{ marginLeft: '3%' }} elevation={0}>
                    <InputBase
                      className={classes.input}
                      placeholder="SALÁRIO"
                      value={inputs.valorSalario}
                      name="valorSalario"
                      required
                      readOnly
                    />
                  </Paper>
                </Grid>

                {inputs.status === 'Afastado' && (
                  <>
                  <Grid item xs={6}>
                  <label className={classes.label}>Data afastamento incial</label>
                  <Paper className={classes.medium} elevation={0}>

                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="Data afastamento inicial"
                      value={moment(inputs.dataAfastamentoInicial).format('DD/MM/YYYY')}
                      inputProps={{ 'aria-label': 'data de nascimento' }}
                    />

                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.grid2}>
                <label className={classes.label} style={{ marginLeft: '3%' }}>Data afastamento final</label>
                <Paper className={classes.medium} style={{ marginLeft: '3%' }} elevation={0}>
                    <InputBase
                      readOnly
                      className={classes.input}
                      placeholder="Data de nascimento"
                      value={moment(inputs.dataAfastamentoFinal).format('DD/MM/YYYY')}
                      inputProps={{ 'aria-label': 'data de nascimento' }}
                    />
                  </Paper>
                </Grid>
                </>
                )}
                {inputs.status === 'Demitido' && (
                  <Grid item xs={6}>
                    <label className={classes.label}>Data da demissão</label>
                    <Paper className={classes.medium} elevation={0}>
                      <InputBase
                        readOnly
                        className={classes.input}
                        placeholder="Data de Demissão"
                        value={moment(inputs.dataDemissao).format('DD/MM/YYYY')}
                        inputProps={{ 'aria-label': 'data de demissao' }}
                      />
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Dados do Registro</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>

                <Grid item xs={6}>
                  <label className={classes.label}>Data de Registro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                      readOnly
                      placeholder="Data do Registro"
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Data da Atualização</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataAtualizacao && formatDateTimeToRender(inputs.dataAtualizacao)}
                      readOnly
                      placeholder="Data da Atualização"
                    />
                  </Paper>
                </Grid>

              </Grid>
            </AccordionDetails>
          </Accordion>

      </>
          )}
    </div>
      </div>
    </div>
  )
}

export default VisualizeRender
